import { Icon } from '@iconify/react';
import {
  Box,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  Divider,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../assets/N2.png';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <Box
      sx={{
        bgcolor: theme.palette.background.dark,
        color: 'white',
        pt: 6,
        pb: 3,
      }}
    >
      <Container maxWidth='lg'>
        {/* Ready to work section */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'space-between',
            borderBottom: '1px solid rgba(255,255,255,0.1)',
            mb: 4,
          }}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={isMobile ? 'center' : 'flex-start'}
            textAlign={isMobile ? 'center' : 'start'}
          >
            <Typography variant='h3' component='h2' gutterBottom>
              {t('Ready to work with us?')}
            </Typography>
            <Typography variant='body1' sx={{ maxWidth: '700px', mb: 4 }}>
              {t(
                'Join us to experience cutting-edge industrial solutions that drive innovation, lasting success.'
              )}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <img src={logo} alt='logo' width='102' height='100' />
          </Box>
        </Box>

        {/* Footer links */}
        <Grid container spacing={4} sx={{ mb: 4 }}>
          <Grid size={{ xs: 12, md: 7 }}>
            <Typography variant='h6' component='h3' gutterBottom>
              {t('New Plastic Industrial Co.')}
            </Typography>
            <Typography variant='body2' sx={{ mb: 2 }}>
              {t('Weaving Quality, Delivering Trust')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
              <IconButton
                icon='mdi:facebook'
                url='https://www.facebook.com/Npico/?locale=ar_AR'
              />
              <IconButton
                icon='mdi:instagram'
                url='https://www.instagram.com/npi.co/'
              />
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, md: 5 }}
            display={'flex'}
            gap={isMobile ? 2 : 6}
          >
            <Box>
              <Typography variant='h6' component='h3' gutterBottom>
                {t('Quick Links')}
              </Typography>
              <FooterLink to='/' text={t('Home')} />
              <FooterLink to='/about-us' text={t('About Us')} />
              <FooterLink to='/blog' text={t('Blog')} />
              <FooterLink to='/products' text={t('Products')} />
            </Box>

            <Divider
              orientation='vertical'
              flexItem
              sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}
            />

            <Box>
              <Typography variant='h6' component='h3' gutterBottom>
                {t('Contact')}
              </Typography>
              <Typography variant='body2' paragraph>
                {isRTL ? '98672469 7 962+' : '+962 7 98672469'}
              </Typography>
              <Typography variant='body2' paragraph>
                info.npico@alhazaagroup.com
              </Typography>
              <Typography variant='body2' paragraph>
                عمان/ القسطل / شارع الشحن الجوي
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            borderTop: '1px solid rgba(255,255,255,0.1)',
            pt: 3,
            textAlign: 'center',
          }}
        >
          <Typography variant='body2' color='text.secondary'>
            {t('Copyright © 2025. All Rights Reserved.')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

// Helper component for footer links
const FooterLink = ({ to, text }) => (
  <Box sx={{ mb: 1 }}>
    <RouterLink to={to} style={{ textDecoration: 'none' }}>
      <Typography
        variant='body2'
        sx={{ color: 'white', '&:hover': { color: '#e0e0e0' } }}
      >
        {text}
      </Typography>
    </RouterLink>
  </Box>
);

// Helper component for social media icons
const IconButton = ({ icon, url }) => (
  <Box
    component='a'
    href={url}
    target='_blank'
    rel='noopener noreferrer'
    sx={{
      width: '36px',
      height: '36px',
      borderRadius: '50%',
      bgcolor: 'rgba(255,255,255,0.1)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: 'none',
      cursor: 'pointer',
      color: 'white',
      '&:hover': {
        bgcolor: 'rgba(255,255,255,0.2)',
      },
      textDecoration: 'none',
    }}
  >
    <Icon icon={icon} width={20} height={20} />
  </Box>
);

export default Footer;
